import { storage } from '@lib/mmkv'
import { shallow } from 'zustand/shallow'
import { createWithEqualityFn } from 'zustand/traditional'
import { Appearance, AppState } from './types'

export const useAppStore = createWithEqualityFn<AppState>(
  (set, get) => ({
    appearance: undefined,
    setAppearance: (appearance) => {
      storage.set('appearance', appearance)
      set({ appearance })
    },
    initializeAppearance: () => {
      set({ appearance: (storage.get('appearance') || 'system') as Appearance })
    },

    // wait with deeplinking until router is ready
    isRouterInitialized: false,
    setRouterInitialized: () => set({ isRouterInitialized: true }),

    // force-update from BE
    isOutdated: false,
    setOutdated: () => set({ isOutdated: true }),

    // servers unreachable
    isServerDown: false,
    setServerDown: () => set({ isServerDown: true }),

    // dev mode
    isDevMode: !!storage.get('isDevMode'),
    setDevMode: () => {
      const { isDevMode } = get()
      const isEnabled = !isDevMode

      set({ isDevMode: isEnabled })
      if (isEnabled) {
        storage.set('isDevMode', 'true')
      } else {
        storage.delete('isDevMode')
      }
    },
  }),
  shallow,
)
